/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Donatekey_Offerpage2Inputs */

const id_forms_donatekey_offerpage2 = /** @type {(inputs: Forms_Donatekey_Offerpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman penawaran`)
};

const ms_forms_donatekey_offerpage2 = /** @type {(inputs: Forms_Donatekey_Offerpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman tawaran`)
};

const da_forms_donatekey_offerpage2 = /** @type {(inputs: Forms_Donatekey_Offerpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilbudsside`)
};

const de_forms_donatekey_offerpage2 = /** @type {(inputs: Forms_Donatekey_Offerpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angebotsseite`)
};

const en_us2_forms_donatekey_offerpage2 = /** @type {(inputs: Forms_Donatekey_Offerpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offer page`)
};

const es_es2_forms_donatekey_offerpage2 = /** @type {(inputs: Forms_Donatekey_Offerpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página de la oferta`)
};

const es_mx2_forms_donatekey_offerpage2 = /** @type {(inputs: Forms_Donatekey_Offerpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página de la oferta`)
};

const fil_forms_donatekey_offerpage2 = /** @type {(inputs: Forms_Donatekey_Offerpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pahina ng offer`)
};

const fr_forms_donatekey_offerpage2 = /** @type {(inputs: Forms_Donatekey_Offerpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page de l'offre`)
};

const it_forms_donatekey_offerpage2 = /** @type {(inputs: Forms_Donatekey_Offerpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagina offerta`)
};

const hu_forms_donatekey_offerpage2 = /** @type {(inputs: Forms_Donatekey_Offerpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajánlat oldal`)
};

const nl_forms_donatekey_offerpage2 = /** @type {(inputs: Forms_Donatekey_Offerpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aanbodpagina`)
};

const no_forms_donatekey_offerpage2 = /** @type {(inputs: Forms_Donatekey_Offerpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilbudsside`)
};

const pl_forms_donatekey_offerpage2 = /** @type {(inputs: Forms_Donatekey_Offerpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strona oferty`)
};

const pt_br2_forms_donatekey_offerpage2 = /** @type {(inputs: Forms_Donatekey_Offerpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offer page`)
};

const pt_forms_donatekey_offerpage2 = /** @type {(inputs: Forms_Donatekey_Offerpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página da oferta`)
};

const ro_forms_donatekey_offerpage2 = /** @type {(inputs: Forms_Donatekey_Offerpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagina ofertei`)
};

const fi_forms_donatekey_offerpage2 = /** @type {(inputs: Forms_Donatekey_Offerpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarjoussivu`)
};

const sv_forms_donatekey_offerpage2 = /** @type {(inputs: Forms_Donatekey_Offerpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erbjudandesida`)
};

const vi_forms_donatekey_offerpage2 = /** @type {(inputs: Forms_Donatekey_Offerpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trang ưu đãi`)
};

const tr_forms_donatekey_offerpage2 = /** @type {(inputs: Forms_Donatekey_Offerpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teklif sayfası`)
};

const cs_forms_donatekey_offerpage2 = /** @type {(inputs: Forms_Donatekey_Offerpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stránka nabídky`)
};

const bg_forms_donatekey_offerpage2 = /** @type {(inputs: Forms_Donatekey_Offerpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Страница на офертата`)
};

const ru_forms_donatekey_offerpage2 = /** @type {(inputs: Forms_Donatekey_Offerpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Страница предложения`)
};

const uk_forms_donatekey_offerpage2 = /** @type {(inputs: Forms_Donatekey_Offerpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сторінка пропозиції`)
};

const ar_forms_donatekey_offerpage2 = /** @type {(inputs: Forms_Donatekey_Offerpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صفحة العرض`)
};

const hi_forms_donatekey_offerpage2 = /** @type {(inputs: Forms_Donatekey_Offerpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑफ़र पेज`)
};

const th_forms_donatekey_offerpage2 = /** @type {(inputs: Forms_Donatekey_Offerpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หน้าข้อเสนอ`)
};

const ja_forms_donatekey_offerpage2 = /** @type {(inputs: Forms_Donatekey_Offerpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オファーページ`)
};

const zh_cn2_forms_donatekey_offerpage2 = /** @type {(inputs: Forms_Donatekey_Offerpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offer page`)
};

const zh_hant1_forms_donatekey_offerpage2 = /** @type {(inputs: Forms_Donatekey_Offerpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offer page`)
};

const ko_forms_donatekey_offerpage2 = /** @type {(inputs: Forms_Donatekey_Offerpage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offer page`)
};

/**
* | output |
* | --- |
* | "Offer page" |
*
* @param {Forms_Donatekey_Offerpage2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_donatekey_offerpage2 = /** @type {((inputs?: Forms_Donatekey_Offerpage2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Donatekey_Offerpage2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_donatekey_offerpage2(inputs)
	if (locale === "ms") return ms_forms_donatekey_offerpage2(inputs)
	if (locale === "da") return da_forms_donatekey_offerpage2(inputs)
	if (locale === "de") return de_forms_donatekey_offerpage2(inputs)
	if (locale === "en-US") return en_us2_forms_donatekey_offerpage2(inputs)
	if (locale === "es-ES") return es_es2_forms_donatekey_offerpage2(inputs)
	if (locale === "es-MX") return es_mx2_forms_donatekey_offerpage2(inputs)
	if (locale === "fil") return fil_forms_donatekey_offerpage2(inputs)
	if (locale === "fr") return fr_forms_donatekey_offerpage2(inputs)
	if (locale === "it") return it_forms_donatekey_offerpage2(inputs)
	if (locale === "hu") return hu_forms_donatekey_offerpage2(inputs)
	if (locale === "nl") return nl_forms_donatekey_offerpage2(inputs)
	if (locale === "no") return no_forms_donatekey_offerpage2(inputs)
	if (locale === "pl") return pl_forms_donatekey_offerpage2(inputs)
	if (locale === "pt-BR") return pt_br2_forms_donatekey_offerpage2(inputs)
	if (locale === "pt") return pt_forms_donatekey_offerpage2(inputs)
	if (locale === "ro") return ro_forms_donatekey_offerpage2(inputs)
	if (locale === "fi") return fi_forms_donatekey_offerpage2(inputs)
	if (locale === "sv") return sv_forms_donatekey_offerpage2(inputs)
	if (locale === "vi") return vi_forms_donatekey_offerpage2(inputs)
	if (locale === "tr") return tr_forms_donatekey_offerpage2(inputs)
	if (locale === "cs") return cs_forms_donatekey_offerpage2(inputs)
	if (locale === "bg") return bg_forms_donatekey_offerpage2(inputs)
	if (locale === "ru") return ru_forms_donatekey_offerpage2(inputs)
	if (locale === "uk") return uk_forms_donatekey_offerpage2(inputs)
	if (locale === "ar") return ar_forms_donatekey_offerpage2(inputs)
	if (locale === "hi") return hi_forms_donatekey_offerpage2(inputs)
	if (locale === "th") return th_forms_donatekey_offerpage2(inputs)
	if (locale === "ja") return ja_forms_donatekey_offerpage2(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_donatekey_offerpage2(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_donatekey_offerpage2(inputs)
	return ko_forms_donatekey_offerpage2(inputs)
});
export { forms_donatekey_offerpage2 as "forms.donateKey.offerPage" }